import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface PrivacyPolicyPageProps {
  onNavigate: (view: string) => void;
}

const PrivacyPolicyPage: React.FC<PrivacyPolicyPageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="privacy" onNavigate={onNavigate} />
);

export default PrivacyPolicyPage;
